import { AppDispatch } from '../store';
import { categoryApi } from './categoryQuery';
import { channelCommonInfoApi } from './channelCommonInfoQuery';
import { channelProductApi } from './channelProduct';
import { channelProductAssortmentApi } from './channelProductAssortment';
import { commonInfoApi } from './commonInfoQuery';
import { editingGroupApi } from './editingGroupQuery';
import { holidayApi } from './holidayQuery';
import { optionApi } from './optionQuery';
import { optionTypeApi } from './optionTypeQuery';
import { optionValueAPI } from './optionValuesQuery';
import { paperGroupApi } from './paperGroupQuery';
import { dropdownsApi } from './pmaDropdownQuery';
import { productMasterApi } from './productMasterQuery';
import { productThemeApi } from './productThemeQuery';
import { uploadS3Api } from './uploadQuery';
import { userApi } from './userQuery';
import { warehouseApi } from './warehouseQuery';

export const resetAllCaches = (dispatch: AppDispatch) => {
  return Promise.all([
    dispatch(uploadS3Api?.util?.resetApiState?.()),
    dispatch(categoryApi?.util?.resetApiState?.()),
    dispatch(optionTypeApi?.util?.resetApiState?.()),
    dispatch(optionApi?.util?.resetApiState?.()),
    dispatch(editingGroupApi?.util?.resetApiState?.()),
    dispatch(commonInfoApi?.util?.resetApiState?.()),
    dispatch(paperGroupApi?.util?.resetApiState?.()),
    dispatch(productMasterApi?.util?.resetApiState?.()),
    dispatch(editingGroupApi?.util?.resetApiState?.()),
    dispatch(channelProductAssortmentApi?.util?.resetApiState?.()),
    dispatch(channelCommonInfoApi?.util?.resetApiState?.()),
    dispatch(productThemeApi?.util?.resetApiState?.()),
    dispatch(channelProductApi?.util?.resetApiState?.()),
    dispatch(optionValueAPI?.util?.resetApiState?.()),
    dispatch(dropdownsApi?.util?.resetApiState?.()),
    dispatch(userApi?.util?.resetApiState?.()),
    dispatch(holidayApi?.util?.resetApiState?.()),
    dispatch(warehouseApi?.util?.resetApiState?.()),
  ]);
};
